import React from "react";
import Helper from "../application/helper";

const PrintAccountStatmentLink = ({ customer_account_number }) => {
    const handlePrint = async () => {
        const url = Helper.route("customer-ledger.showAccountStatement", {
            customer_account_id: customer_account_number,
        });
        const printFrame = document.createElement("iframe");
        printFrame.style.visibility = "hidden";
        printFrame.style.position = "fixed";
        printFrame.style.right = "0";
        printFrame.style.bottom = "0";
        printFrame.src = url;
        document.body.appendChild(printFrame);
        printFrame.onload = () => {
            printFrame.contentWindow.print();
        };
    };

    return (
        <button
            className="btn btn-sm btn-secondary ml-2"
            style={{ paddingRight: "10px" }}
            onClick={handlePrint}
        >
            Print Account Statement
        </button>
    );
};

export default PrintAccountStatmentLink;
